import {
	RouteBaseDefinition,
	RouteBasePath
} from '@core/interfaces/route.interface';


export enum AdminConsoleRoutesEnum {
	FccVersionCreateFormPage = 'fcc-versions/create',
	FccVersionListPage = 'fcc-versions',
	FccVersionUpdateFormPage = 'fcc-versions/:fccVersionId/update',
	GlobalStatisticsPage = 'global-statistics',
	UsageDtrPage = 'usage-dtr',
	UsageDtrPageTabVolumeModelTab = 'usage-dtr/volume/:usagePeriod',
	UsageGkPage = 'usage-gk',
	UsageGkPageTabUsageModelTab = 'usage-gk/usage/:usagePeriod',
	UserDetailPage = 'users/:userId',
	UserListPage = 'users'
}

export interface AdminConsoleStatisticsPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.GlobalStatisticsPage;
}

export interface AdminConsoleUsageDtrPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.UsageDtrPage;
}

export interface AdminConsoleUsageDtrPageTabVolumeModelTabRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.UsageDtrPageTabVolumeModelTab;
	params: {
		usagePeriod: string
	};
}

export interface AdminConsoleUsageGkPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.UsageGkPage;
}

export interface AdminConsoleUsageGkPageTabUsageModelTabRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.UsageGkPageTabUsageModelTab;
	params: {
		usagePeriod: string
	};
}

export interface AdminConsoleUserDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.UserDetailPage;
	params: {
		userId: string
	};
}

export interface AdminConsoleUserListPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.UserListPage;
}

export interface AdminConsoleFccVersionCreateFormPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.FccVersionCreateFormPage;
}

export interface AdminConsoleFccVersionListPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.FccVersionListPage;
}

export interface AdminConsoleFccVersionUpdateFormPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.AdminConsole;
	path: AdminConsoleRoutesEnum.FccVersionUpdateFormPage;
	params: { fccVersionId: string };
}
